export default {
  label: 'Externe Organisation',
  route: 'externeorganisation',
  className: 'externeOrganisation',
  fields: [
    {
      label: 'Name',
      field: 'name',
      type: 'string'
    },
    {
      label: 'Stadt',
      field: 'stadt',
      type: 'string'
    },
    {
      label: 'Beschreibung',
      field: 'beschreibung',
      type: 'string'
    },
    {
      label: 'Kurzname',
      field: 'kurzname',
      type: 'string'
    },
    {
      label: 'Land',
      cardinality: 'single',
      icon: 'globe',
      field: 'land',
      type: 'object',
      render: 'stringRep'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/schema/list/ExterneOrganisation.js